// extracted by mini-css-extract-plugin
module.exports = {"filterBadge":"FilterBadge_filterBadge__38sVi","filterBadgeActive":"FilterBadge_filterBadgeActive__3kxof"};